<div class="main-window">
    <div *ngIf="(filteredPresets$ | async) as presets" class="presets">
        <div *ngFor="let p of presets">
             <div class="preset-row" [ngClass]="currentPresetId == p.id ? 'highlight-row' : ''">
                <div class="p-id"> {{ p.id }}</div>
                <div class="p-name" (click)="loadPreset(p)"> {{ p.name }}</div>
                <div class="p-layout"> 
                    <img [src]="layoutIdToSymbol(p.layoutId)" alt="Preset Type" />
                </div>
                <div class="p-actions"> 
                    <mat-icon class="svg-icon" (click)="showPreset(p)">info</mat-icon>
                    <mat-icon class="svg-icon" (click)="deletePreset(p.id)">delete</mat-icon>
                </div>
             </div>
             <hr class="divider" />

        </div>

    </div>
</div>